<template>
  <el-dialog
      v-if="dialogVisible"
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      title="附件信息"
      width="1000px">
    <el-table
        ref="vmTable"
        module="basic"
        border
        :data="fileList">
      <el-table-column prop="fileName" label="附件名称" align="left"/>
      <el-table-column prop="note" label="备注" align="left" show-overflow-tooltip/>
      <el-table-column
          fixed="right"
          align="center"
          width="100px"
          label="操作">
        <template v-slot="scope">
          <el-button type="primary" @click="download(scope.row)">下载</el-button>
          <el-button :disabled="scope.row.itemType !==40" type="danger" @click="deleteOne(scope.$index,scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </el-dialog>
</template>

<script>

  export default {
    name: "PurchaseOrderAttachment",
    components: {},
    data() {
      return {
        dialogVisible: false,
        fileList:[],
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        this.$http
          .get("basic", `sapDeliveryBills/getById/${row.pkId}`)
          .then((resp) => {
            if (resp.success){
              this.fileList=resp.data.accessoryList;
            }

          }).catch(()=>{
            this.$message.error("附件获取失败");
          });
      },
      download(row) {
        let data = {
          name:row.fileName,
          uuid:row.filePath,
        };
        this.$http.exportFile("basic","files/download",data).then(res => {
          console.log(res);
          let blob = new Blob([res.data],{type:"application"});
          let fileName = decodeURI(res.config.params.name);
          if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            let a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = fileName;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            URL.revokeObjectURL(a.href);
            document.body.removeChild(a);
          }
        });
      },

      deleteOne(index,row) {
        this.$http.delete("basic","accessories",row.accessoryID)
          .then(()=>{
            this.$message.success("删除成功");
            this.fileList.splice(index,1);
          }).catch(()=>{
            this.$message.error("删除失败");
          });
      },
    },
  };
</script>

<style scoped>

</style>